const PRIORITY_KEYS = [
  "priorityUser",
  "priority_user",
  "hospitalPriorityUser",
  "hospital_priority_user",
  "priority_user_hospital",
];

const isPriorityValue = (value) => String(value) === "1";

export const hasPriorityHospital = (order = {}) => {
  const directMatch = PRIORITY_KEYS.find((key) => isPriorityValue(order?.[key]));

  if (directMatch) {
    return true;
  }

  return [order?.hospital, order?.order_by].some((entity) =>
    PRIORITY_KEYS.some((key) => isPriorityValue(entity?.[key]))
  );
};

export const comparePriorityThenTime = (first = {}, second = {}) => {
  const firstPriority = hasPriorityHospital(first) ? 0 : 1;
  const secondPriority = hasPriorityHospital(second) ? 0 : 1;

  if (firstPriority !== secondPriority) {
    return firstPriority - secondPriority;
  }

  if (first?.tym === second?.tym) {
    return 0;
  }

  return first?.tym > second?.tym ? -1 : 1;
};